import { AppException, ErrorCode } from '@/core/exceptions';

import type { NotificationRepository } from '../../domain/repositories';
import type { ArchiveNotificationsRequest, GetNotificationsRequest, MarkNotificationsReadRequest, NotificationActionResponse, NotificationsResponse } from '../../domain/types';
import type { NotificationDatasource } from '../datasources/notificationDatasource';
import { notificationDatasource } from '../datasources/notificationDatasource';

export class NotificationRepositoryImpl implements NotificationRepository {
  constructor(private readonly datasource: NotificationDatasource = notificationDatasource) {}

  async getNotifications(request: GetNotificationsRequest): Promise<NotificationsResponse> {
    try {
      return await this.datasource.getNotifications(request);
    } catch (error) {
      throw this.handleError(error, 'Failed to fetch notifications');
    }
  }
  async getUnreadCount(): Promise<number> {
    try {
      return await this.datasource.getUnreadCount();
    } catch (error) {
      throw this.handleError(error, 'Failed to fetch unread notification count');
    }
  }
  async markRead(request: MarkNotificationsReadRequest): Promise<NotificationActionResponse> {
    try {
      return await this.datasource.markRead(request);
    } catch (error) {
      throw this.handleError(error, 'Failed to mark notifications read');
    }
  }
  async archive(request: ArchiveNotificationsRequest): Promise<NotificationActionResponse> {
    try {
      return await this.datasource.archive(request);
    } catch (error) {
      throw this.handleError(error, 'Failed to archive notifications');
    }
  }
  private handleError(error: unknown, fallbackMessage: string): AppException {
    if (error instanceof AppException) return error;
    return new AppException({
      code: ErrorCode.UNKNOWN_ERROR,
      message: error instanceof Error ? error.message : fallbackMessage,
      userMessage: error instanceof Error ? error.message : fallbackMessage,
    });
  }
}

export const notificationRepository: NotificationRepository = new NotificationRepositoryImpl();
